// extracted by mini-css-extract-plugin
module.exports = {"language-list":"LanguageLinkBar_language-list__q0OJS"};